import ActionsList from 'front-office/components/cancellation-id-card/actions-list';
import { CancellationIdCardSearchPersonCrumbs } from 'front-office/constants/cancellation-id-card-crumbs';
import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import PersonSearch from 'shell/components/shared/person-search';

const CancellationIdCardSearchPersonPage = (): React.ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={CancellationIdCardSearchPersonCrumbs} />
      <PersonSearch
        pathname="/sportello/annullamento-carta/annulla"
        action={ActionsList}
        addedTitle="- Annullamento Carta Identità"
      />
    </Fragment>
  );
};

CancellationIdCardSearchPersonPage.displayName =
  'Cancellation id card search person page component';

export default CancellationIdCardSearchPersonPage;
